module.exports = __webpack_public_path__ + "static/Footwear2-dadcb11aacfab105cdbab57217745056.png";